import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RoleInterface } from "../models/role/role.interface";
import { Constants } from "../data/constants";
import { SuccessDto } from "../models/success-dto";
import { environment } from "src/environments/environment";
import { GroupAuthorityInterface } from "../models/group-authority/group-authority.interface";

@Injectable({
  providedIn: "root",
})
export class GroupAuthorityService {
  constructor(private http: HttpClient) {}

  getAllGroupAuthorities(): Observable<GroupAuthorityInterface[]> {
    return this.http.get<GroupAuthorityInterface[]>(
      `${environment.APP_PORT + Constants.GROUP_AUTHORITY_ENDPOINT + "/all"}`
    );
  }
}
